<template>
  <div id="app" class="d-sm-flex align-items-center">
    <router-view></router-view>
  </div>
</template>

<script>
  import "./assets/css/main.scss";
  export default {
    metaInfo() {
      return {
        title: 'Notre équipe vous rappelle gratuitement',
        link: [
          {rel: 'canonical', href: location.href}
        ],
        meta: [
          { name: 'description', content: 'Choisissez la date et l\'heure à laquelle vous souhaitez être rappelé. Un membre de notre équipe répond à vos questions et vous conseille gratuitement !'},
          { property: 'og:title', content: 'Notre équipe vous rappelle gratuitement'},
          { property: 'og:site_name', content: 'Quickly'},
          { property: 'og:type', content: 'website'},
          { property: 'og:url', content: location.href},
          { property: 'og:image', content: '@/assets/img/quickly.png'},
          { property: 'og:description', content: 'Choisissez la date et l\'heure à laquelle vous souhaitez être rappelé. Un membre de notre équipe répond à vos questions et vous conseille gratuitement !'}
        ]
      }
    },
  }
</script>

<style>
  @import "./assets/css/vanilla-calendar.css";
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
#app {
  font-family: 'Poppins';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  min-height: 100vh;
  /*display: flex;
  align-items: center;*/
  width: 100%;
  overflow-y: auto;
}
</style>
